import styled from "styled-components";
import { palette } from "styled-theme";

const MenuWrapper = styled.div`
  height: 100%;
  border-radius: 5px;

  .light {
    .ant-menu-item-selected {
      background-color: transparent !important;
      .anticon {
        background: ${palette("primary", 0)};
        padding: 10px;
        color: ${palette("surfaceColor", 0)};
      }
    }
    .anticon {
      background: ${palette("bgColor", 0)};
      padding: 10px;
      border-radius: 20px;
      margin: 0 5px;
    }
    .ant-menu-item-only-child {
      padding: 0px !important;
      background-color: transparent;
    }
    .ant-menu-item-selected::after {
      border: none;
    }
  }
`;

export default MenuWrapper;
